import { render } from "./text-intro.vue?vue&type=template&id=8b8ebd00&scoped=true"
import script from "./text-intro.vue?vue&type=script&lang=js"
export * from "./text-intro.vue?vue&type=script&lang=js"

import "./text-intro.vue?vue&type=style&index=0&id=8b8ebd00&scoped=true&lang=css"
import "./text-intro.vue?vue&type=style&index=1&id=8b8ebd00&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8ebd00"]])

export default __exports__